import { faCheck, faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import goldTicket from 'assets/images/waitingLine/gold-ticket-v2.png';
import silverTicket from 'assets/images/waitingLine/Silver-ticket-v2.png';
import { WaitingLineType } from 'lib/graphql/graphql';
import { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { ContainedButton, Separator } from 'styles/styles';

import {
  BreakWordText,
  BulletPointIcon,
  GridCard,
  StyledList,
  TicketImage,
  WaitingLineDescription,
  WaitingLineTitle,
} from './styles';

interface WaitingLineTypeCardProps {
  waitingLineType: WaitingLineType;
  titleId: string;
  handleSelect: (waitingLineType: WaitingLineType) => void;
  waitingLineDescriptionIds: string[];
}

function WaitingLineTypeCard(props: WaitingLineTypeCardProps) {
  const {
    waitingLineType,
    handleSelect,
    waitingLineDescriptionIds,
    titleId,
  } = props;

  const select = useCallback(() => {
    handleSelect(waitingLineType);
  }, [handleSelect, waitingLineType]);

  const ticketImg = waitingLineType === WaitingLineType.Gold ? goldTicket : silverTicket;

  return (
    <GridCard container direction="column" p={2} display="flex" justifyContent="center" alignItems="center" height="100%">
      <TicketImage src={ticketImg} />
      <WaitingLineTitle variant="h5" textAlign="center">
        <FormattedMessage id={titleId} />
      </WaitingLineTitle>
      <WaitingLineDescription>
        <FormattedMessage id={`waiting_line_${waitingLineType}_access`} />
      </WaitingLineDescription>
      <Separator />
      <StyledList dense>
        {waitingLineDescriptionIds.map((description) => (
          <ListItem key={description}>
            <ListItemIcon>
              <BulletPointIcon icon={faCheck} />
            </ListItemIcon>
            <ListItemText
              primary={(
                <BreakWordText>
                  <FormattedMessage id={description} />
                </BreakWordText>
              )}
            />
          </ListItem>
        ))}
      </StyledList>
      <Separator />
      <ContainedButton
        onClick={select}
        color="secondary"
        endIcon={<FontAwesomeIcon icon={faChevronRight} />}
      >
        <FormattedMessage id="waiting_line_type_create" values={{ type: waitingLineType }} />
      </ContainedButton>
    </GridCard>
  );
}

export default WaitingLineTypeCard;
